require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./truncatedtext"), require("./constants"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./flexlayout", "./truncatedtext", "./constants"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./truncatedtext"), require("./constants")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./flexlayout"], root["./truncatedtext"], root["./constants"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__30__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[35],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = __webpack_require__(14);

var _utils = __webpack_require__(4);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var scrollIntoViewIfNeeded = _utils.domUtils.scrollIntoViewIfNeeded,
    isElementInView = _utils.domUtils.isElementInView;

var StaticList = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(StaticList, _Component);

  function StaticList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_itemsRenderer", function (items, ref) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: ref
      }, items);
    });
    return _this;
  }

  var _proto = StaticList.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var initialIndex = this.props.initialIndex;

    if (initialIndex > 0) {
      this.scrollTo(initialIndex);
    }
  };

  _proto.scrollAround = function scrollAround(index) {
    this._staticScrollTo(index);
  };

  _proto.scrollTo = function scrollTo(index) {
    this._staticScrollTo(index, true);
  };

  _proto.getVisibleRange = function getVisibleRange() {
    var children = this._container.children;
    var parent = this.props.getScrollParent();
    var startRange = null;
    var endRange = null;

    for (var i = 0; i < children.length; i += 1) {
      var child = children[i];

      if (isElementInView(child, parent)) {
        if (startRange == null) {
          startRange = i;
        }

        endRange = i;
      } else if (endRange != null) {
        break;
      }
    }

    return [startRange || 0, endRange || 0];
  };

  _proto._staticScrollTo = function _staticScrollTo(index, scrollTo) {
    if (this._container && index >= 0) {
      var children = this._container.children;

      if (children.length > index) {
        var child = children[index];

        if (scrollTo) {
          child.parentNode.parentNode.scrollTop = child.offsetTop;
        } else {
          scrollIntoViewIfNeeded(this.props.getScrollParent(), child);
        }
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        length = _this$props.length,
        itemsRenderer = _this$props.itemsRenderer,
        itemRenderer = _this$props.itemRenderer;
    var containerRenderer = itemsRenderer || this._itemsRenderer;
    var items = [];

    for (var i = 0; i < length; i += 1) {
      items.push(itemRenderer(i, i));
    }

    return containerRenderer(items, function (itemsContainer) {
      return _this2._container = (0, _reactDom.findDOMNode)(itemsContainer);
    }); // eslint-disable-line no-return-assign
  };

  return StaticList;
}(_react.Component);

exports["default"] = StaticList;
(0, _defineProperty2["default"])(StaticList, "propTypes", {
  length: _propTypes["default"].number.isRequired,
  itemsRenderer: _propTypes["default"].func,
  itemRenderer: _propTypes["default"].func.isRequired,
  initialIndex: _propTypes["default"].number,
  getScrollParent: _propTypes["default"].func.isRequired
});

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactList = _interopRequireDefault(__webpack_require__(327));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var VirtualizedList = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(VirtualizedList, _Component);

  function VirtualizedList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (list) {
      _this._list = list;
    });
    return _this;
  }

  var _proto = VirtualizedList.prototype;

  _proto.scrollAround = function scrollAround(index) {
    var visibleRange = this._list.getVisibleRange();

    if (visibleRange[0] > index) {
      this._list.scrollAround(Math.max(0, Math.ceil(index - (visibleRange[1] - visibleRange[0]) / 2)));
    } else if (visibleRange[1] < index) {
      this._list.scrollAround(Math.min(this.props.length - 1, Math.floor(index + (visibleRange[1] - visibleRange[0]) / 2)));
    } else if (index === visibleRange[0] || index === visibleRange[1]) {
      this._list.scrollAround(index);
    }
  };

  _proto.scrollTo = function scrollTo(index) {
    this._list.scrollTo(index);
  };

  _proto.getVisibleRange = function getVisibleRange() {
    return this._list.getVisibleRange();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        listType = _this$props.listType,
        length = _this$props.length,
        initialIndex = _this$props.initialIndex,
        itemSizeGetter = _this$props.itemSizeGetter,
        itemSizeEstimator = _this$props.itemSizeEstimator,
        itemRenderer = _this$props.itemRenderer,
        itemsRenderer = _this$props.itemsRenderer;
    return /*#__PURE__*/_react["default"].createElement(_reactList["default"], {
      type: listType,
      itemRenderer: itemRenderer,
      itemsRenderer: itemsRenderer,
      length: length,
      initialIndex: initialIndex,
      ref: this._ref,
      itemSizeEstimator: itemSizeEstimator,
      itemSizeGetter: itemSizeGetter
    });
  };

  return VirtualizedList;
}(_react.Component);

exports["default"] = VirtualizedList;
(0, _defineProperty2["default"])(VirtualizedList, "propTypes", {
  length: _propTypes["default"].number.isRequired,
  itemRenderer: _propTypes["default"].func.isRequired,
  itemsRenderer: _propTypes["default"].func,
  initialIndex: _propTypes["default"].number,
  listType: _propTypes["default"].oneOf(['uniform', 'simple', 'variable']),
  itemSizeEstimator: _propTypes["default"].func,
  itemSizeGetter: _propTypes["default"].func
});
(0, _defineProperty2["default"])(VirtualizedList, "defaultProps", {
  listType: 'uniform',
  selectionMode: 'none'
});

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(328);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _button = _interopRequireDefault(__webpack_require__(15));

var _flexlayout = _interopRequireWildcard(__webpack_require__(16));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _overflowMenuHorizontal_ = _interopRequireDefault(__webpack_require__(41));

var _utils = __webpack_require__(4);

__webpack_require__(330);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize;

var ListItem = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ListItem, _Component);

  function ListItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onContextMenu", function (e) {
      _this.props.onMenu(e.pageX, e.pageY, e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._buttonNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_iconOnclick", function (event) {
      var onIconClick = _this.props.onIconClick;
      onIconClick(event);
    });
    return _this;
  }

  var _proto = ListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        disableHover = _this$props.disableHover,
        hoveredAbove = _this$props.hoveredAbove,
        hoveredBelow = _this$props.hoveredBelow,
        hoveredActive = _this$props.hoveredActive,
        hoveredCenter = _this$props.hoveredCenter,
        hoveredRight = _this$props.hoveredRight,
        hoveredLeft = _this$props.hoveredLeft,
        outerClassName = _this$props.outerClassName,
        className = _this$props.className,
        children = _this$props.children,
        selected = _this$props.selected,
        active = _this$props.active,
        focus = _this$props.focus,
        listItemFocus = _this$props.listItemFocus,
        index = _this$props.index,
        length = _this$props.length,
        selectable = _this$props.selectable,
        separator = _this$props.separator,
        onMenu = _this$props.onMenu,
        actions = _this$props.actions,
        role = _this$props.role,
        icon = _this$props.icon,
        style = _this$props.style,
        disabled = _this$props.disabled,
        ellipsisTitle = _this$props.ellipsisTitle,
        hideMenuButton = _this$props.hideMenuButton,
        showOverflow = _this$props.showOverflow,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["disableHover", "hoveredAbove", "hoveredBelow", "hoveredActive", "hoveredCenter", "hoveredRight", "hoveredLeft", "outerClassName", "className", "children", "selected", "active", "focus", "listItemFocus", "index", "length", "selectable", "separator", "onMenu", "actions", "role", "icon", "style", "disabled", "ellipsisTitle", "hideMenuButton", "showOverflow"]);
    var classNames = (0, _utils.classnames)('ba-common-listItem', {
      hoveredAbove: hoveredAbove,
      hoveredActive: hoveredActive,
      hoveredBelow: hoveredBelow,
      disableHover: disabled || disableHover,
      hoveredCenter: hoveredCenter,
      hoveredRight: hoveredRight,
      hoveredLeft: hoveredLeft,
      selectable: selectable,
      active: disabled ? false : active,
      focus: focus,
      selected: disabled ? false : selected,
      separator: separator,
      disabled: disabled
    });
    var outerClassNames = (0, _utils.classnames)('ba-common-listItem-wrapper ', outerClassName, {
      focus: focus
    });
    var innerClassNames = (0, _utils.classnames)('ba-common-listItem__cmBtn ba-common-listItem-with-right-icon', {
      listItemFocus: listItemFocus
    });
    return /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], (0, _extends2["default"])({}, sanitize(others, ListItem), {
      alignItems: "center",
      onContextMenu: onMenu ? this._onContextMenu : null,
      className: classNames + " " + className,
      "aria-setsize": length,
      "aria-posinset": index + 1,
      "aria-selected": !!selected,
      role: role,
      style: style,
      outerClassName: "" + outerClassNames
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "list-item-children"
    }, children), actions, !icon && onMenu && !hideMenuButton && /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
      className: "" + innerClassNames
    }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
      hasIconOnly: true,
      kind: "ghost",
      size: "small",
      iconDescription: ellipsisTitle,
      tooltipPosition: "left",
      "aria-label": ellipsisTitle,
      disabled: disabled,
      "data-tid": "ba-common-listItem__context-menu",
      "data-list-context-menu": true,
      ref: this._ref,
      onClick: this._onContextMenu,
      renderIcon: function renderIcon() {
        return showOverflow !== false ? /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
          iconId: _overflowMenuHorizontal_["default"].id
        }) : null;
      }
    })), icon && /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
      className: "ba-common-listItem__iconBtn"
    }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
      "data-tid": "ba-common-listItem__button",
      ref: this._ref,
      button: false,
      intent: "",
      size: "small" // List is using _onItemMouseDown and _onItemClick to detact selectChange, if onItemMouseDown listener triggered, onItemClick won't trigger
      // when user click on the custom icon, let the listener run when browser dispatches mousedown event,
      // if necessary, user can stop the mousedown event from bubbling up to list.
      // Also force stop the event from bubbling up to list when browser dispatches click event
      // This way guarantees the list will detect select change once when user click on custom icon
      ,
      onMouseDown: this._iconOnclick,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      variant: "inline",
      icon: icon
    })));
  };

  return ListItem;
}(_react.Component);

exports["default"] = ListItem;
(0, _defineProperty2["default"])(ListItem, "propTypes", {
  className: _propTypes["default"].string,
  role: _propTypes["default"].string,
  disableHover: _propTypes["default"].bool,
  length: _propTypes["default"].number.isRequired,
  index: _propTypes["default"].number.isRequired,
  selected: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  focus: _propTypes["default"].bool,
  listItemFocus: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired,
  onMenu: _propTypes["default"].func,
  icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  onIconClick: _propTypes["default"].func,
  selectable: _propTypes["default"].bool,
  separator: _propTypes["default"].bool,
  showOverflow: _propTypes["default"].bool,
  hoveredAbove: _propTypes["default"].bool,
  hoveredBelow: _propTypes["default"].bool,
  hoveredCenter: _propTypes["default"].bool,
  hoveredRight: _propTypes["default"].bool,
  hoveredLeft: _propTypes["default"].bool,
  hoveredActive: _propTypes["default"].bool,
  actions: _propTypes["default"].any,
  style: _propTypes["default"].object,
  outerClassName: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  ellipsisTitle: _propTypes["default"].string,
  hideMenuButton: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(ListItem, "defaultProps", {
  role: 'option',
  className: '',
  outerClassName: '',
  style: {}
});

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__30__;

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(325);


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;

var _List = _interopRequireWildcard(__webpack_require__(326));

exports["default"] = _List["default"];
exports.List = _List["default"];
exports.expandEventTypes = _List.expandEventTypes;
exports.activeEventTypes = _List.activeEventTypes;

var _ListItem = _interopRequireDefault(__webpack_require__(107));

exports.ListItem = _ListItem["default"];

var _VirtualizedList = _interopRequireDefault(__webpack_require__(105));

exports.VirtualizedList = _VirtualizedList["default"];

var _StaticList = _interopRequireDefault(__webpack_require__(104));

exports.StaticList = _StaticList["default"];

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = exports.activeEventTypes = exports.expandEventTypes = exports.selectionEventTypes = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = __webpack_require__(14);

var _utils = __webpack_require__(4);

var _constants = __webpack_require__(30);

var _StaticList = _interopRequireDefault(__webpack_require__(104));

var _VirtualizedList = _interopRequireDefault(__webpack_require__(105));

__webpack_require__(106);

var _DefaultItemRenderer = __webpack_require__(329);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// Constants
var selectionEventTypes = _constants.listEventTypes.selectionEventTypes;
exports.selectionEventTypes = selectionEventTypes;
var expandEventTypes = _constants.listEventTypes.expandEventTypes;
exports.expandEventTypes = expandEventTypes;
var activeEventTypes = _constants.listEventTypes.activeEventTypes; // Utils

exports.activeEventTypes = activeEventTypes;
var sanitize = _utils.propsUtils.sanitize;
var getKeyName = _utils.keyboardUtils.getKeyName,
    keyNames = _utils.keyboardUtils.keyNames,
    isKey = _utils.keyboardUtils.isKey;
var getElementCenter = _utils.domUtils.getElementCenter,
    getElementTopLeft = _utils.domUtils.getElementTopLeft,
    getElementBottomLeft = _utils.domUtils.getElementBottomLeft,
    offsetWithinBoundingRect = _utils.domUtils.offsetWithinBoundingRect,
    getEventClientOffset = _utils.domUtils.getEventClientOffset,
    IE11 = _utils.domUtils.IE11;
var uniqueId = _utils.lodash.uniqueId,
    clamp = _utils.lodash.clamp,
    range = _utils.lodash.range;
var VIRTUALIZATION_COUNT = 30;
var LONG_PRESS_TIME = 500;

function isVirtualized(length, virtualized) {
  return virtualized || virtualized !== false && length > VIRTUALIZATION_COUNT;
} // Using this variable to retain value of listItemID to activate focus on ESCAPE.
// Tried using state but it failed to retain state after context menu opened.


var listItemID = ''; // Using this variable to reatin value to check if focus was cicked on mousedown or keypress

var focusEventType = false;

var List = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(List, _Component);

  function List(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_itemRenderer", function (itemIndex, key) {
      var itemProps = {
        index: itemIndex,
        active: _this.isItemSelected(itemIndex),
        focus: _this._isFocusedItem(itemIndex),
        listItemFocus: _this._isFocusedListItem(itemIndex),
        key: _this.props.getKey ? _this.props.getKey(itemIndex) : key,
        id: _this._getListItemId(itemIndex),
        length: _this.props.length,
        selectable: _this.props.selectionMode !== 'none'
      };

      if (_this.props.selectionMode !== 'none' && _this.props.isSelected) {
        itemProps.selected = _this.props.isSelected(itemIndex);
      }

      if (_this.props.hierarchical) {
        itemProps.expanded = _this.props.isExpanded(itemIndex);
        itemProps.onExpand = _this._onItemExpand;
      }

      var itemSpec = _this.props.options ? _this.props.options[itemIndex] : {};

      var item = _this._renderItemUsingRendererPriority(itemSpec, itemProps);

      return _this._updateItemWithCallbacks(itemIndex, item);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderItemUsingRendererPriority", function (itemSpec, itemProps) {
      if (itemSpec.itemRenderer) {
        var renderConfigs = itemSpec.renderConfigs;

        var updatedItemProps = _this._updateItemPropsWithCallbacks(itemProps);

        return /*#__PURE__*/_react["default"].createElement(itemSpec.itemRenderer, {
          itemSpec: itemSpec,
          itemProps: updatedItemProps,
          renderConfigs: renderConfigs
        });
      }

      var index = itemProps.index;
      return _this.props.itemRenderer ? _this.props.itemRenderer(index, itemProps) : /*#__PURE__*/_react["default"].createElement(_DefaultItemRenderer.DefaultItemRenderer, {
        itemSpec: itemSpec,
        itemProps: _this._updateItemPropsWithCallbacks(itemProps)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_updateItemWithCallbacks", function (itemIndex, item) {
      // TODO: callbacks should be more specific and not override native events
      // ie onDoubleClick -> onExpand
      if (!_this._itemsMap[itemIndex]) {
        _this._itemsMap[itemIndex] = {
          ref: _this._onItemRef.bind((0, _assertThisInitialized2["default"])(_this), itemIndex),
          onClick: _this._onItemClick.bind((0, _assertThisInitialized2["default"])(_this), itemIndex),
          onMouseDown: _this.props.clickSelection ? null : _this._onItemMouseDown.bind((0, _assertThisInitialized2["default"])(_this), itemIndex),
          onTouchStart: _this._onItemTouchStart.bind((0, _assertThisInitialized2["default"])(_this), itemIndex),
          onTouchEnd: _this._onItemTouchEnd.bind((0, _assertThisInitialized2["default"])(_this), itemIndex),
          onMenu: _this._onItemMenu.bind((0, _assertThisInitialized2["default"])(_this), itemIndex),
          onDoubleClick: _this._onItemDoubleClick.bind((0, _assertThisInitialized2["default"])(_this), itemIndex),
          item: null,
          itemProps: null
        };
      }

      _this._itemsMap[itemIndex].itemProps = item.props;
      var _this$_itemsMap$itemI = _this._itemsMap[itemIndex],
          ref = _this$_itemsMap$itemI.ref,
          onClick = _this$_itemsMap$itemI.onClick,
          onMouseDown = _this$_itemsMap$itemI.onMouseDown,
          onTouchStart = _this$_itemsMap$itemI.onTouchStart,
          onTouchEnd = _this$_itemsMap$itemI.onTouchEnd,
          onMenu = _this$_itemsMap$itemI.onMenu,
          onDoubleClick = _this$_itemsMap$itemI.onDoubleClick;
      var cloneProps = {
        ref: ref,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd
      };

      if (_this.props.hierarchical && onDoubleClick) {
        cloneProps.onDoubleClick = onDoubleClick;
      }

      if (item.props.onMenu !== null && (_this.props.onMenu || item.props.onMenu) && onMenu) {
        cloneProps.onMenu = onMenu;
      }

      return _react["default"].cloneElement(item, cloneProps);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onItemRef", function (index, node) {
      _this._itemsMap[index].item = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getItemNode", function (index) {
      return _this._itemsMap[index].item;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getItemProps", function (index) {
      return _this._itemsMap[index].itemProps;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onItemExpand", function (index, expand) {
      _this._notifyExpand(expand ? expandEventTypes.EXPAND : expandEventTypes.COLLAPSE, index);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onItemDoubleClick", function (index, e) {
      if (!e.isDefaultPrevented() && !e.ctrlKey && !e.metaKey) {
        _this._onItemSelect(index, e);
      }

      var _this$_getItemProps = _this._getItemProps(index),
          onDoubleClick = _this$_getItemProps.onDoubleClick;

      onDoubleClick && onDoubleClick(e);

      if (!e.isDefaultPrevented()) {
        _this.setState({}, function () {
          _this._notifyExpand(expandEventTypes.TOGGLE, index);
        });
      }

      e.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTouchStart", function (e) {
      if (e.touches && e.touches.length === 1) {
        _this._longPressTimer = setTimeout(function () {
          _this.setState({
            toggleOnClick: true
          });

          window.addEventListener('touchend', _this._onTouchOutside, true);
        }, LONG_PRESS_TIME);
        _this.props.onTouchStartCapture && _this.props.onTouchStartCapture(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTouchOutside", function (e) {
      if (!offsetWithinBoundingRect(getEventClientOffset(e), _this._node.getBoundingClientRect()) || !_this._node.contains(e.target)) {
        _this._clearLongPress();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_clearLongPress", function () {
      clearTimeout(_this._longPressTimer);

      if (_this.state.toggleOnClick) {
        window.removeEventListener('touchend', _this._onTouchOutside, true);

        _this.setState({
          toggleOnClick: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTouchEnd", function (e) {
      if (!_this.state.toggleOnClick) {
        _this._clearLongPress();
      }

      _this.props.onTouchEndCapture && _this.props.onTouchEndCapture(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTouchMove", function (e) {
      _this._processTouch = false;

      if (!_this.state.toggleOnClick) {
        _this._clearLongPress();
      }

      _this.props.onTouchMoveCapture && _this.props.onTouchMoveCapture(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseDown", function () {
      focusEventType = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      _this.props.onKeyDown && _this.props.onKeyDown(e); // IE11 hack: There's a bug in IE in which the list item steals focus from the List when you click on it.
      // this should not happen as the listItem is a div without a tabIndex, yet in IE it does.
      // The e.target === e.currentTarget check is to ensure that keyDown events that did not occur on the List
      // are not handled (ie; those that occured on an input box within a ListItem), and since the listItem is not
      // the List the key events in IE will not work. Thus we have a second IE11 only condition which allows for
      // the target to be a listItem.

      if (e.target === e.currentTarget || IE11 && e.target.classList && e.target.classList.contains('ba-common-listItem')) {
        _this._doOnKeyDown(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getScrollParent", function () {
      return _this._node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onFocus", function () {
      _this.setState({
        focused: true
      });

      setTimeout(function () {
        if (!focusEventType) {
          _this.setState({
            showFocusClass: true
          });

          focusEventType = false;
        }
      }, 1);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function () {
      _this.props.onScrollCloseMenu && _this.props.onScrollCloseMenu();

      if (_this.props.getMoreData) {
        var scrollParent = _this._getScrollParent();

        var pagesRemainingUntilBottom = (scrollParent.scrollHeight - (scrollParent.scrollTop + scrollParent.clientHeight)) / scrollParent.clientHeight;

        if (pagesRemainingUntilBottom <= 3) {
          _this.props.getMoreData();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyUp", function (e) {
      if (isKey(e, keyNames.TAB)) {
        _this.setState({
          showFocusClass: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function () {
      if (_this.props.toggleContextMenu) {
        console.warn('The property toggleContextMenu will be deprecated soon.'); // eslint-disable-line

        _this.props.toggleContextMenu();
      }

      _this.setState({
        showFocusClass: false,
        showListItemFocus: false
      });

      _this.setState({
        focused: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._node = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refList", function (list) {
      _this._list = list;
    });
    var active = props.initialIndex != null ? props.initialIndex : -1;

    if (props.activeIndex != null) {
      active = props.activeIndex;
    }

    _this.state = {
      focused: false,
      pivot: active,
      lastClick: active,
      active: active,
      toggleOnClick: false,
      showFocusClass: false,
      showListItemFocus: false
    };
    _this._id = uniqueId('__list_');
    _this._itemsMap = {};
    return _this;
  }

  var _proto = List.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var activeIndex = _ref.activeIndex,
        lastClickIndex = _ref.lastClickIndex,
        pivotIndex = _ref.pivotIndex,
        length = _ref.length,
        virtualized = _ref.virtualized;

    if (this._isVirtualized() !== isVirtualized(length, virtualized)) {
      this._prevScrollTop = this._node.scrollTop;
    }

    if (activeIndex != null) {
      if (lastClickIndex == null || lastClickIndex === -1) {
        lastClickIndex = 0;
      }

      if (pivotIndex == null || pivotIndex === -1) {
        pivotIndex = 0;
      }

      this.setState({
        active: activeIndex,
        lastClick: lastClickIndex,
        pivot: pivotIndex
      });
    } else if (length < this.props.length && this.state.active >= length) {
      this.setState({
        active: length - 1,
        pivot: length - 1,
        lastClick: length - 1
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    if (this._prevScrollTop) {
      requestAnimationFrame(function () {
        _this2._node && (_this2._node.scrollTop = _this2._prevScrollTop);
        _this2._prevScrollTop = null;

        if (_this2._isVirtualized()) {
          // force firing a scroll event immediately to avoid flickering
          var event = document.createEvent('Event');
          event.initEvent('scroll', true, false);
          _this2._node && _this2._node.dispatchEvent(event);
        }

        if (_this2.props.activeIndex == null && _this2.state.active !== prevState.active) {
          _this2.scrollAround(_this2.state.active);
        }
      });
    } else if (this.props.activeIndex == null && this.state.active !== prevState.active) {
      this.scrollAround(this.state.active);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('touchend', this._onTouchOutside, true);
    clearTimeout(this._longPressTimer);
  };

  _proto.getActiveIndex = function getActiveIndex() {
    return this.state.active;
  };

  _proto.getVisibleRange = function getVisibleRange() {
    return this._list.getVisibleRange();
  };

  _proto._isFocusedItem = function _isFocusedItem(index) {
    /* Set focus state to first item in list if no active index is present */
    if (index === 0 && this._getActiveIndex() < 0 && this.state.showFocusClass) {
      return true;
    }

    return (this.props.alwaysDisplayActive || this.state.focused) && this._getActiveIndex() === index && this.state.showFocusClass;
  };

  _proto._isFocusedListItem = function _isFocusedListItem(index) {
    return this._getActiveIndex() === index && this.state.showListItemFocus;
  };

  _proto.handleKeyEvent = function handleKeyEvent(e) {
    this._doOnKeyDown(e);
  };

  _proto.scrollAround = function scrollAround(index) {
    this._list.scrollAround(index);

    if (this.props.activeIndex == null) {
      this._notifyActiveChange(activeEventTypes.ABSOLUTE, index);

      this.setState({
        active: index,
        pivot: index,
        lastClick: index
      });
    }
  };

  _proto.scrollTo = function scrollTo(index) {
    this._list.scrollTo(index);

    if (this.props.activeIndex == null) {
      this._notifyActiveChange(activeEventTypes.ABSOLUTE, index);

      if (this.props.selectionMode === 'none') {
        this.setState({
          active: index,
          pivot: index,
          lastClick: index
        });
      }
    }
  };

  _proto.isItemSelected = function isItemSelected(index) {
    var _this$props = this.props,
        selectionMode = _this$props.selectionMode,
        alwaysDisplayActive = _this$props.alwaysDisplayActive;
    /* NOTE: when selectionMode is none, make keyboard navigation still available if needed by setting alwaysDisplayActive = true */

    if (selectionMode === 'none' && !alwaysDisplayActive) {
      return false;
    }

    return (alwaysDisplayActive || this.state.focused) && this._getActiveIndex() === index;
  };

  _proto._updateItemPropsWithCallbacks = function _updateItemPropsWithCallbacks(itemProps) {
    return (0, _extends2["default"])({}, itemProps, {
      ref: this._onItemRef.bind(this, itemProps.index),
      onClick: this._onItemClick.bind(this, itemProps.index),
      onMouseDown: this.props.clickSelection ? null : this._onItemMouseDown.bind(this, itemProps.index),
      onTouchStart: this._onItemTouchStart.bind(this, itemProps.index),
      onTouchEnd: this._onItemTouchEnd.bind(this, itemProps.index),
      onMenu: itemProps.onMenu && this._onItemMenu.bind(this, itemProps.index),
      onDoubleClick: this._onItemDoubleClick.bind(this, itemProps.index)
    });
  };

  _proto._getActiveIndex = function _getActiveIndex() {
    return this.props.activeIndex == null ? this.state.active : this.props.activeIndex;
  };

  _proto._getListItemId = function _getListItemId(index) {
    return this._id + "_" + (this.props.getItemId ? this.props.getItemId(index) : index);
  };

  _proto._isToggleOnClick = function _isToggleOnClick() {
    return this.state.toggleOnClick || this.props.toggleOnClick;
  };

  _proto._onItemMenu = function _onItemMenu(index, x, y, e) {
    var _this3 = this;

    var _this$_getItemProps2 = this._getItemProps(index),
        onMenu = _this$_getItemProps2.onMenu; // TODO if the user right clicked a selected element then we do not want to redo the selection


    if (this.props.isSelected && this.props.isSelected(index)) {
      e.stopPropagation();
    } else if (e.isDefaultPrevented()) {
      this.setState({
        active: index,
        lastClick: index,
        pivot: index
      });

      this._notifyActiveChange(activeEventTypes.ABSOLUTE, index);

      this._notifySelectionChange(selectionEventTypes.SET, index);
    } else if (!e.ctrlKey && !e.metaKey && (!this.props.isSelected || !this.props.isSelected(index))) {
      this._onItemSelect(index, e);
    }

    e.preventDefault(); // adjust x, y if outside of list bounds

    var bounds = this._node.getBoundingClientRect();

    var adjustedX = Math.max(bounds.left, Math.min(x, bounds.right));
    var adjustedY = Math.max(bounds.top, Math.min(y, bounds.bottom));
    onMenu && onMenu(adjustedX, adjustedY, e, index);
    e.persist();
    this.setState({}, function () {
      _this3.props.onMenu && _this3.props.onMenu(adjustedX, y, e, index);
    });
  };

  _proto._onItemTouchStart = function _onItemTouchStart(index, e) {
    this._processTouch = e.touches.length === 1;

    var _this$_getItemProps3 = this._getItemProps(index),
        onTouchStart = _this$_getItemProps3.onTouchStart;

    onTouchStart && onTouchStart(e);
  };

  _proto._onItemTouchEnd = function _onItemTouchEnd(index, e) {
    this._handledByTouchStart = false;
    this._handledByMouseDown = false;

    if (this._processTouch && this.props.isSelected && !this.props.isSelected(index)) {
      this._onItemSelect(index, e);

      this._handledByTouchStart = true;
    }

    var _this$_getItemProps4 = this._getItemProps(index),
        onTouchEnd = _this$_getItemProps4.onTouchEnd;

    onTouchEnd && onTouchEnd(e);
  };

  _proto._onItemMouseDown = function _onItemMouseDown(index, e) {
    this._handledByMouseDown = false;

    if (!this._handledByTouchStart) {
      if (this.props.isSelected && !this.props.isSelected(index)) {
        this._onItemSelect(index, e);

        this._handledByMouseDown = true;
      }

      var _this$_getItemProps5 = this._getItemProps(index),
          onMouseDown = _this$_getItemProps5.onMouseDown;

      onMouseDown && onMouseDown(e);
    } else {
      // Need this here in case user switches between tap and mouse interfaces (ie. touchscreen laptop)
      this._handledByTouchStart = false;
      this._handledByMouseDown = true;
    }
  };

  _proto._onItemClick = function _onItemClick(index, e) {
    this.setState({
      showFocusClass: false,
      firstSelectedIndex: index,
      showListItemFocus: false
    });

    this._onItemSelect(index, e);
  };

  _proto._onItemSelect = function _onItemSelect(index, e) {
    var selectionMode = this.props.selectionMode;

    if (selectionMode === 'disabled' || this._handledByMouseDown || this._handledByTouchStart) {
      return;
    }

    var newState = {
      active: index,
      lastClick: index
    };

    if (e.shiftKey) {
      e.preventDefault(); // prevent unwanted higlighting in IE
    }

    if (selectionMode === 'single' || selectionMode === 'none') {
      if (e.ctrlKey || e.metaKey) {
        this._notifySelectionChange(selectionEventTypes.TOGGLE, index);
      } else {
        this._notifySelectionChange(selectionEventTypes.SET, index);
      }
    } else if (selectionMode === 'multi') {
      if (e.ctrlKey || e.metaKey) {
        this._notifySelectionChange(selectionEventTypes.TOGGLE, index, true);

        newState.pivot = index;
      } else if (e.shiftKey) {
        this._rangeChange(index);
      } else {
        this._notifySelectionChange(this._isToggleOnClick() ? selectionEventTypes.TOGGLE : selectionEventTypes.SET, index, true);

        newState.pivot = index;
      }
    }

    this._notifyActiveChange(activeEventTypes.ABSOLUTE, index);

    this.setState(newState);
  };

  _proto._doOnKeyDown = function _doOnKeyDown(e) {
    var _this4 = this;

    var _this$props2 = this.props,
        length = _this$props2.length,
        selectionMode = _this$props2.selectionMode,
        hierarchical = _this$props2.hierarchical,
        onExpand = _this$props2.onExpand,
        isExpanded = _this$props2.isExpanded,
        onMenu = _this$props2.onMenu;
    var _this$state = this.state,
        pivot = _this$state.pivot,
        active = _this$state.active,
        lastClick = _this$state.lastClick,
        firstSelectedIndex = _this$state.firstSelectedIndex,
        showListItemFocus = _this$state.showListItemFocus;
    var F10 = keyNames.F10,
        LEFT = keyNames.LEFT,
        RIGHT = keyNames.RIGHT,
        ESCAPE = keyNames.ESCAPE,
        A = keyNames.A,
        HOME = keyNames.HOME,
        UP = keyNames.UP,
        END = keyNames.END,
        DOWN = keyNames.DOWN,
        ENTER = keyNames.ENTER,
        SPACE = keyNames.SPACE,
        TAB = keyNames.TAB;
    var newState = {};
    var expandFlag;
    var activeEventType; // set the new active node up or down

    var i = active;

    switch (getKeyName(e)) {
      case F10:
        this.setState({
          showFocusClass: false,
          showListItemFocus: false
        });

        if (e.shiftKey && selectionMode !== 'none' && selectionMode !== 'disabled') {
          e.preventDefault();

          var _this$_list$getVisibl = this._list.getVisibleRange(),
              startRange = _this$_list$getVisibl[0],
              endRange = _this$_list$getVisibl[1];

          this._doKeyMenu(this._itemsMap, lastClick, startRange, endRange, this.props.onMenu);
        }

        break;

      case LEFT:
        if (showListItemFocus) {
          this.setState({
            showFocusClass: true,
            showListItemFocus: false
          });
        } else if (!e.shiftKey && hierarchical && i >= 0) {
          if (isExpanded(i)) {
            e.preventDefault();
            expandFlag = false;
          } else if (i > 0) {
            i = this.props.getParentIndex(i);
            activeEventType = activeEventTypes.ABSOLUTE;
          }
        }

        break;

      case RIGHT:
        // on right expand if children exists
        // on right goto button if expand is true
        // on right goto button if children does not exists
        if (isExpanded(i)) {
          this.setState({
            showFocusClass: false,
            showListItemFocus: true
          });
        } else if (!e.shiftKey && hierarchical && i >= 0) {
          e.preventDefault();
          expandFlag = true;
        } else if (onMenu) {
          this.setState({
            showFocusClass: false,
            showListItemFocus: true
          });
        }

        break;

      case ESCAPE:
        this.setState({
          showFocusClass: false,
          showListItemFocus: false
        });
        i = -1;
        activeEventType = activeEventTypes.ABSOLUTE;

        if (listItemID) {
          var ele = document.getElementById(listItemID).parentNode.parentNode.parentNode.parentNode.parentNode;
          ele.focus();
          focusEventType = false;
        }

        break;

      case A:
        this.setState({
          showFocusClass: false,
          showListItemFocus: false
        });

        if (e.ctrlKey || e.metaKey) {
          e.preventDefault();

          if (selectionMode === 'multi') {
            this._notifySelectionChange(selectionEventTypes.SELECT_ALL, null);
          }
        }

        break;

      case HOME: // fall through to arrow up
      // eslint-disable-next-line no-fallthrough

      case UP:
        e.preventDefault();

        if (e.altKey || isKey(e, HOME)) {
          if (i === 0) {
            return;
          }

          i = 0;
          activeEventType = activeEventTypes.ABSOLUTE;
        } else if (i === -1) {
          i = length - 1;
          activeEventType = activeEventTypes.ABSOLUTE;
        } else if (i <= 0) {
          return;
        } else {
          i -= 1;
          activeEventType = activeEventTypes.UP;
        }

        if (e.shiftKey) {
          if (selectionMode === 'single') {
            this._notifySelectionChange(selectionEventTypes.SET, i);
          } else if (selectionMode === 'multi') {
            if (e.altKey) {
              this._rangeChange(i);
            } else if (active <= pivot && firstSelectedIndex >= active) {
              this._notifySelectionChange(selectionEventTypes.ADD, active);

              this._notifySelectionChange(selectionEventTypes.ADD, active - 1);
            } else {
              this._notifySelectionChange(selectionEventTypes.REMOVE, active);
            }
          }

          newState.lastClick = i;
        }

        break;

      case END: // fall through to arrow down
      // eslint-disable-next-line no-fallthrough

      case DOWN:
        e.preventDefault();

        if (e.altKey || isKey(e, END)) {
          if (i === length - 1) {
            return;
          }

          i = length - 1;
          activeEventType = activeEventTypes.ABSOLUTE;
        } else if (i === -1) {
          i = 0;
          activeEventType = activeEventTypes.ABSOLUTE;
        } else if (i >= length - 1) {
          return;
        } else {
          activeEventType = activeEventTypes.DOWN;
          i += 1;
        }

        if (e.shiftKey) {
          if (selectionMode === 'single') {
            this._notifySelectionChange(selectionEventTypes.SET, i);
          } else if (selectionMode === 'multi') {
            if (e.altKey) {
              this._rangeChange(i);
            } else if (active >= pivot && firstSelectedIndex <= active) {
              this._notifySelectionChange(selectionEventTypes.ADD, active);

              this._notifySelectionChange(selectionEventTypes.ADD, active + 1);
            } else {
              this._notifySelectionChange(selectionEventTypes.REMOVE, active);
            }
          }

          newState.lastClick = i;
        }

        break;

      case ENTER:
        if (showListItemFocus) {
          this._notifySelectionChange(selectionEventTypes.SET, i);

          var bounds = this._node.getBoundingClientRect();

          var listItemId = this._getListItemId(i);

          listItemID = this._getListItemId(i);
          var element = document.getElementById(listItemId);
          var PageX = window.pageXOffset + element.getBoundingClientRect().left;
          var PageY = window.pageYOffset + element.getBoundingClientRect().top;
          var adjustedX = Math.max(bounds.left, Math.min(PageX, bounds.right)); // For Defect 253298: Pass in menu button element to callback when triggered by enter key.
          // Regression test: Trigger context menu via enter key near edge of the page in admin or MUI.

          var menuBtn = {
            target: element.querySelector('[data-tid="ba-common-listItem__context-menu"]') // get menu button element to pass as the trigger node for context menu callback

          };
          this.setState({
            active: i,
            lastClick: i,
            pivot: i
          }, function () {
            _this4.props.onMenu && _this4.props.onMenu(adjustedX, PageY, menuBtn);
          });
          break;
        }

      // fall through to space
      // eslint-disable-next-line no-fallthrough

      case SPACE:
        this.setState({
          showFocusClass: false,
          showListItemFocus: false
        });
        e.preventDefault();

        if (i >= 0) {
          if (selectionMode === 'single') {
            this._notifySelectionChange(selectionEventTypes.SET, i, true);

            newState.pivot = i;
          } else if (selectionMode === 'multi') {
            if (e.shiftKey) {
              this._rangeChange(i);
            } else if (e.ctrlKey || e.metaKey) {
              this._notifySelectionChange(selectionEventTypes.TOGGLE, i, true);

              newState.pivot = i;
            } else {
              this._notifySelectionChange(this._isToggleOnClick() ? selectionEventTypes.TOGGLE : selectionEventTypes.SET, i, true);

              newState.pivot = i;
            }
          }
        }

        newState.lastClick = i;
        break;

      case TAB:
        this.setState({
          showFocusClass: true
        });
        listItemID = null;
        break;

      default:
        break;
    }

    if (activeEventType) {
      this._notifyActiveChange(activeEventType, i);

      newState.active = i;
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }

    if (hierarchical && expandFlag != null && onExpand && i >= 0) {
      this._notifyExpand(expandFlag ? expandEventTypes.EXPAND : expandEventTypes.COLLAPSE, i);
    }
  };

  _proto._doKeyMenu = function _doKeyMenu(visibleItems, selectedIndex, lowerRange, upperRange, onMenu) {
    if (selectedIndex < lowerRange) {
      // top of list
      var _getElementTopLeft = getElementTopLeft(this._node),
          x = _getElementTopLeft.x,
          y = _getElementTopLeft.y;

      onMenu && onMenu(x, y);
    } else if (selectedIndex > upperRange) {
      // bottom of list
      var _getElementBottomLeft = getElementBottomLeft(this._node),
          _x = _getElementBottomLeft.x,
          _y = _getElementBottomLeft.y;

      onMenu && onMenu(_x, _y);
    } else {
      // item is within view, get its dom node, fire on it
      var selectedItem = visibleItems[selectedIndex].item;

      if (selectedItem) {
        var element = (0, _reactDom.findDOMNode)(selectedItem);
        var contextMenuElement = element.querySelector('[data-list-context-menu]') || element;

        var _getElementCenter = getElementCenter(contextMenuElement),
            _x2 = _getElementCenter.x,
            _y2 = _getElementCenter.y;

        onMenu && onMenu(_x2, _y2);
      }
    }
  };

  _proto._rangeChange = function _rangeChange(index) {
    var lastIndex = this.props.length - 1;
    var pivot = clamp(this.state.pivot, 0, lastIndex);
    var lastClick = clamp(this.state.lastClick, 0, lastIndex);
    var belowPivot = index > pivot;
    var belowLastClick = index > lastClick;
    var added;
    var removed; // There are 3!=6 possible arrangements of index, pivot and lastClick
    // below are the 6 branches (min/max counted) covering each arrangement

    if (belowPivot && belowLastClick) {
      removed = range(Math.min(pivot, lastClick), pivot);
      added = range(pivot, index + 1);
    } else if (belowPivot && !belowLastClick) {
      removed = range(index + 1, lastClick + 1);
      added = range(pivot, index + 1);
    } else if (belowLastClick) {
      removed = range(lastClick, index);
      added = range(index, pivot + 1);
    } else {
      removed = range(Math.max(pivot, lastClick), pivot);
      added = range(pivot, index - 1);
    }

    if (this.props.onSelectionChange && (removed.length || added.length)) {
      var itemProps = this._getItemProps(index);

      var disabled = itemProps.disabled;
      this.props.onSelectionChange({
        type: selectionEventTypes.COMPOSITE,
        added: added,
        removed: removed,
        last: index,
        disabled: !!disabled
      });
    }
  };

  _proto._notifyExpand = function _notifyExpand(type, index) {
    if (this.props.onExpand) {
      this.props.onExpand({
        type: type,
        index: index
      });
    }
  };

  _proto._notifySelectionChange = function _notifySelectionChange(type, index, pivot) {
    if (pivot === void 0) {
      pivot = false;
    }

    if ((!Array.isArray(index) || index.length > 0) && this.props.onSelectionChange) {
      var disabled;

      if (type !== 'select_all') {
        var itemProps = this._getItemProps(index);

        disabled = itemProps.disabled;
      } else {
        disabled = false;
      }

      this.props.onSelectionChange({
        type: type,
        index: index,
        pivot: pivot,
        last: index,
        disabled: !!disabled
      });
    }
  };

  _proto._notifyActiveChange = function _notifyActiveChange(type, index) {
    var onActiveChange = this.props.onActiveChange;

    if (onActiveChange && (type !== activeEventTypes.ABSOLUTE || this.state.active !== index)) {
      onActiveChange({
        type: type,
        index: index,
        prevIndex: this.state.active
      });
    }
  };

  _proto._isVirtualized = function _isVirtualized() {
    return isVirtualized(this.props.length, this.props.virtualized);
  };

  _proto.focus = function focus() {
    this._node && this._node.focus();
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        className = _this$props3.className,
        listType = _this$props3.listType,
        length = _this$props3.length,
        initialIndex = _this$props3.initialIndex,
        selectionMode = _this$props3.selectionMode,
        role = _this$props3.role,
        hierarchical = _this$props3.hierarchical,
        tabIndex = _this$props3.tabIndex,
        itemSizeGetter = _this$props3.itemSizeGetter,
        itemSizeEstimator = _this$props3.itemSizeEstimator,
        itemsRenderer = _this$props3.itemsRenderer,
        overflowX = _this$props3.overflowX,
        overflowY = _this$props3.overflowY,
        fullHeight = _this$props3.fullHeight,
        style = _this$props3.style,
        selectionMark = _this$props3.selectionMark,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, ["className", "listType", "length", "initialIndex", "selectionMode", "role", "hierarchical", "tabIndex", "itemSizeGetter", "itemSizeEstimator", "itemsRenderer", "overflowX", "overflowY", "fullHeight", "style", "selectionMark"]);
    var active = this.state.active;
    var classNames = (0, _utils.classnames)('ba-common-list', 'ba--focusable', {
      selectable: selectionMode !== 'none',
      'selection-mark': selectionMark
    });
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, List), {
      ref: this._ref,
      className: classNames + " " + className,
      id: this._getListItemId(),
      role: role || (hierarchical ? 'tree' : 'listbox'),
      tabIndex: tabIndex,
      onKeyDown: this._onKeyDown,
      onMouseDown: this._onMouseDown,
      onKeyUp: this._onKeyUp,
      onFocus: this._onFocus,
      onBlur: this._onBlur,
      onTouchStartCapture: this._onTouchStart,
      onTouchEndCapture: this._onTouchEnd,
      onTouchMoveCapture: this._onTouchMove,
      onScroll: this._onScroll,
      "aria-activedescendant": active >= 0 ? this._getListItemId(active) : null,
      "aria-multiselectable": selectionMode === 'multi',
      style: (0, _extends2["default"])({
        overflowX: overflowX,
        overflowY: overflowY,
        height: fullHeight ? '100%' : 'auto'
      }, style)
    }), this._isVirtualized() ? /*#__PURE__*/_react["default"].createElement(_VirtualizedList["default"], {
      id: this._getListItemId(),
      listType: listType,
      itemRenderer: this._itemRenderer,
      itemsRenderer: itemsRenderer,
      length: length,
      initialIndex: initialIndex,
      ref: this._refList,
      itemSizeEstimator: itemSizeEstimator,
      itemSizeGetter: itemSizeGetter
    }) : /*#__PURE__*/_react["default"].createElement(_StaticList["default"], {
      itemRenderer: this._itemRenderer,
      itemsRenderer: itemsRenderer,
      length: length,
      initialIndex: initialIndex,
      ref: this._refList,
      getScrollParent: this._getScrollParent
    }));
  };

  return List;
}(_react.Component);

exports["default"] = List;
(0, _defineProperty2["default"])(List, "propTypes", {
  activeIndex: _propTypes["default"].number,
  alwaysDisplayActive: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  clickSelection: _propTypes["default"].bool,
  fullHeight: _propTypes["default"].bool,
  getItemId: _propTypes["default"].func,
  getKey: _propTypes["default"].func,
  getMoreData: _propTypes["default"].func,
  getParentIndex: _propTypes["default"].func,
  hierarchical: _propTypes["default"].bool,
  initialIndex: _propTypes["default"].number,
  isExpanded: _propTypes["default"].func,
  isSelected: _propTypes["default"].func,
  itemSizeEstimator: _propTypes["default"].func,
  itemSizeGetter: _propTypes["default"].func,
  itemRenderer: _propTypes["default"].func,
  itemsRenderer: _propTypes["default"].func,
  lastClickIndex: _propTypes["default"].number,
  length: _propTypes["default"].number.isRequired,
  listType: _propTypes["default"].oneOf(['uniform', 'simple', 'variable']),
  menuProps: _propTypes["default"].object,
  onActiveChange: _propTypes["default"].func,
  onExpand: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onMenu: _propTypes["default"].func,
  onScrollCapture: _propTypes["default"].func,
  onScrollCloseMenu: _propTypes["default"].func,
  onSelectionChange: _propTypes["default"].func,
  onTouchEndCapture: _propTypes["default"].func,
  onTouchMoveCapture: _propTypes["default"].func,
  onTouchStartCapture: _propTypes["default"].func,
  options: _propTypes["default"].array,
  overflowX: _propTypes["default"].string,
  overflowY: _propTypes["default"].string,
  pivotIndex: _propTypes["default"].number,
  role: _propTypes["default"].string,
  selectionMode: _propTypes["default"].oneOf(['none', 'disabled', 'single', 'multi']),
  style: _propTypes["default"].object,
  tabIndex: _propTypes["default"].oneOf([0, -1]),
  toggleContextMenu: _propTypes["default"].func,
  toggleOnClick: _propTypes["default"].bool,
  virtualized: _propTypes["default"].bool,
  selectionMark: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(List, "defaultProps", {
  listType: 'uniform',
  selectionMode: 'none',
  tabIndex: 0,
  className: '',
  style: {}
});

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

module.exports = require("react-list");

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-list{padding:0;margin:0;display:block;max-height:100%;overflow-y:auto;overflow-x:hidden;flex-shrink:1;will-change:scroll-position;touch-action:manipulation;cursor:default;user-select:none}.ba-common-list:focus{outline:none}.ba-common-list .ba-common-listItem-wrapper.is-focus{box-shadow:inset 0 0 0 2px #a8c0f3;box-shadow:inset 0 0 0 2px hsl(var(--focus-h, 221), var(--focus-s, 76%), var(--focus-l, 81%))}\n", ""]);

// exports
exports.locals = {
	"menuClassName": "\"ba-common-menu\""
};

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.DefaultItemRenderer = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _flexlayout = __webpack_require__(16);

var _utils = __webpack_require__(4);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _ListItem = _interopRequireDefault(__webpack_require__(107));

var _List = _interopRequireDefault(__webpack_require__(106));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var MenuClassName = _List["default"].menuClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;

function createIcon(className, iconId) {
  return /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
    className: (0, _utils.classnames)(className + "__icon"),
    iconId: iconId,
    size: "small"
  });
}

var DefaultItemRenderer = function DefaultItemRenderer(props) {
  var itemProps = props.itemProps,
      itemSpec = props.itemSpec;
  var label = itemSpec.label,
      disabled = itemSpec.disabled,
      _leftIcon = itemSpec.icon,
      _rightIcon = itemSpec.rightIcon,
      others = (0, _objectWithoutPropertiesLoose2["default"])(itemSpec, ["label", "disabled", "icon", "rightIcon"]);
  var leftIcon = _leftIcon ? createIcon(MenuClassName, _leftIcon.id) : null;
  var rightIcon = _rightIcon ? createIcon(MenuClassName, _rightIcon.id) : null;
  var listItemProps = (0, _extends2["default"])({
    disabled: disabled,
    className: (0, _utils.classnames)(MenuClassName + "__item")
  }, itemProps, sanitize(others, null, 'id', 'value'));
  var flexItemProps = {
    grow: true,
    basis: 'auto',
    className: (0, _utils.classnames)(MenuClassName + "__item--text")
  };
  var textProps = {
    className: 'cursor',
    value: label,
    location: 'middle'
  };
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], listItemProps, leftIcon, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, flexItemProps, /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], textProps)), rightIcon);
};

exports.DefaultItemRenderer = DefaultItemRenderer;
DefaultItemRenderer.propTypes = {
  itemSpec: _propTypes["default"].object,
  itemProps: _propTypes["default"].object
};

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".mobile .ba-common-listItem{min-height:40px;min-width:100%}.ba-common-listItem{background-color:transparent;position:relative;min-height:32px;padding-left:16px;padding-right:16px}.ba-common-listItem:before{content:'';min-height:32px;visibility:hidden;width:0}.ba-common-listItem.is-hoveredBelow:after{content:'';position:absolute;border-width:0;border-top-width:2px;border-style:solid;left:0;right:0;pointer-events:none;z-index:1;bottom:-1px}.ba-common-listItem.is-hoveredAbove:after{content:'';position:absolute;border-width:0;border-top-width:2px;border-style:solid;left:0;right:0;pointer-events:none;z-index:1;top:-1px}.ba-common-listItem.is-hoveredCenter{outline:2px solid;border-right-width:2px;padding-right:6px;border-left-width:2px;padding-left:6px}.ba-common-listItem.is-separator:after{content:'';height:1px;border-width:0;border-bottom-width:1px;border-style:solid;margin:0 8px 0 8px;left:0;bottom:0;right:0;position:absolute}.ba-common-listItem__cmBtn,.ba-common-listItem__iconBtn{visibility:hidden}[dir=\"ltr\"].ba-common-listItem__cmBtn,.ba-common-listItem__iconBtn{margin-right:-8px}[dir=\"rtl\"].ba-common-listItem__cmBtn,.ba-common-listItem__iconBtn{margin-right:0;margin-left:-8px}[dir=\"ltr\"] .ba-common-listItem__cmBtn,.ba-common-listItem__cmBtn,[dir=\"ltr\"] .ba-common-listItem__iconBtn,.ba-common-listItem__iconBtn{margin-right:-8px}[dir=\"rtl\"] .ba-common-listItem__cmBtn,[dir=\"rtl\"] .ba-common-listItem__iconBtn{margin-right:0;margin-left:-8px}.ba-common-listItem__cmBtn.is-listItemFocus{visibility:visible}[dir=\"ltr\"].ba-common-listItem__iconBtn{margin-left:8px}[dir=\"rtl\"].ba-common-listItem__iconBtn{margin-left:0;margin-right:8px}[dir=\"ltr\"] .ba-common-listItem__iconBtn,.ba-common-listItem__iconBtn{margin-left:8px}[dir=\"rtl\"] .ba-common-listItem__iconBtn{margin-left:0;margin-right:8px}.ba-common-listItem button[data-tid=\"ba-common-listItem__context-menu\"]{border-color:transparent;color:inherit}.ba-common-listItem button[data-tid=\"ba-common-listItem__context-menu\"] span.bx--assistive-text{visibility:hidden}.ba-common-listItem button[data-tid=\"ba-common-listItem__context-menu\"].bx--btn::before{content:none}.ba-common-listItem button[data-tid=\"ba-common-listItem__context-menu\"].bx--btn:focus{border-color:transparent}.ba--focusable:focus div:last-child>.ba-common-listItem.is-separator:after{border-bottom-width:0px}.list-item-children{display:flex;width:100%;align-items:center}.ba-common-listItem:not(.is-active){background-color:#fff;box-shadow:inset 0 0 0 1px transparent}.ba-common-listItem:not(.is-active) [type=\"button\"]:focus{background-color:transparent;box-shadow:inset 0 0 0 1px transparent}.ba-common-listItem.is-active{background-color:transparent;box-shadow:inset 0px 0 0 2px #0f62fe}.ba-common-listItem.is-active [type=\"button\"]:hover{background-color:transparent;box-shadow:inset 0 2px 0 0 transparent,  inset 0 -2px 0 0 transparent}.ba-common-listItem.is-active [type=\"button\"]:focus{background-color:transparent;box-shadow:inset 0 2px 0 0 transparent,  inset 0 -2px 0 0 transparent}.ba-common-listItem.is-active [type=\"button\"]:active{background-color:transparent;box-shadow:inset 0 2px 0 0 transparent,  inset 0 -2px 0 0 transparent}.ba-common-listItem.is-active.is-selected{background-color:#e5e5e5;box-shadow:inset 0 0 0 2px #0f62fe}.ba-common-listItem.is-active.is-selected:hover{background-color:#cacaca}.ba-common-listItem.is-active.is-selected [type=\"button\"]:focus{background-color:transparent;box-shadow:inset 0 2px 0 0 transparent,  inset 0 -2px 0 0 transparent}.selection-mark .ba-common-listItem.is-active.is-selected{box-shadow:inset 4px 0 0 0 #0f62fe,inset 0 0 0 2px #0f62fe}.ba-common-listItem.is-selected{border-color:#1f57a4;border-color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1);background-color:#e0e0e0;color:#343334}.ba-common-listItem.is-selected [type=\"button\"]:focus{background-color:#e0e0e0;box-shadow:inset 0 0 0 1px transparent}.selection-mark .ba-common-listItem.is-selected{box-shadow:inset 4px 0 0 0 #0f62fe}.ba-common-listItem.is-separator:after{border-color:#e0e0e0}.ba-common-listItem.is-hoveredBelow:after,.ba-common-listItem.is-hoveredAbove:after{border-color:#1f57a4;border-color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1)}.ba-common-listItem.is-hoveredCenter{outline-color:#1f57a4;outline-color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1);border-color:#1f57a4;border-color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1)}.ba-common-listItem__cmBtn:hover .ba-common-svgIcon{color:#1f57a4;color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1)}.ba-common-listItem.is-disabled{cursor:not-allowed}.ba-common-listItem__iconBtn:hover .is-icon{color:#1f57a4;color:hsla(var(--primary1-h, 214.73684), var(--primary1-s, 68.20513%), var(--primary1-l, 38.23529%), 1)}body.mobile .ba-common-listItem.is-selected .ba-common-listItem__cmBtn,body.mobile .ba-common-listItem.is-selected .ba-common-listItem__iconBtn{visibility:visible}body:not(.mobile) .ba-common-listItem:hover:not(.is-disabled) .ba-common-listItem__cmBtn,body:not(.mobile) .ba-common-listItem:hover:not(.is-disabled) .ba-common-listItem__iconBtn{visibility:visible}body:not(.mobile) .ba-common-listItem:not(.is-active):hover{background-color:#e5e5e5;color:#161616;border-color:transparent}body:not(.mobile) .ba-common-listItem:not(.is-active):hover [type=\"button\"]:focus{background-color:#e5e5e5;box-shadow:inset 0 0 0 1px #e5e5e5}body:not(.mobile) .ba-common-listItem:not(.is-active):hover [type=\"button\"]:hover{background-color:transparent;box-shadow:inset 0 0 0 1px transparent}body:not(.mobile) .ba-common-listItem.is-disableHover:hover{background-color:transparent;color:#525252}.ba--highContrast .ba-common-listItem:hover{border-left-style:solid;border-left-width:4px}.ba--highContrast .ba-common-listItem.is-selected{border-left-style:double;border-left-width:4px}@media screen and (-ms-high-contrast: active){.ba--highContrast .ba-common-listItem.is-selected{border:1px solid #fff}}.ba--highContrast .ba-common-listItem.is-active{border-left-style:solid;border-left-width:4px}\n", ""]);

// exports


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--horizontal_32");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[324,0]]]);
});